<template>
  <div class="basic_wrap">
    <bsHeader
      v-if="!isYouTubeVideo"
      title=""
      @backurl="$router.back()"
    />
		
    <!-- 播放器 -->
    <div class="player-container">
      <div
        class="video-poster"
        :class="{ hidden: videoReady || isYouTubeVideo }"
        :style="{ backgroundImage: posters ? 'url(' + posters + ')' : 'linear-gradient(135deg, #111, #333)' }"
      />
      <iframe
        v-if="isYouTubeVideo && youtubeEmbedUrl"
        ref="youtubePlayer"
        class="youtube-player"
        :src="youtubeEmbedUrl"
        title="YouTube video player"
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerpolicy="strict-origin-when-cross-origin"
        allowfullscreen
      />
      <video
        v-show="!isYouTubeVideo"
        ref="videoPlayer"
        preload="metadata"
        playsinline
        webkit-playsinline
        :poster="posters"
        :class="{ loading: !videoReady, ready: videoReady }"
        @loadeddata="onVideoLoaded"
        @canplay="onVideoCanPlay"
        @timeupdate="onTimeUpdate"
        @loadedmetadata="onLoadedMetadata"
        @play="isPlaying = true"
        @pause="isPlaying = false"
        @ended="onVideoEnded"
        @error="onVideoError"
      />

      <!-- 加载占位图标 -->
      <div
        class="loading-placeholder"
        :class="{ hidden: videoReady || isYouTubeVideo }"
        @click="handleLoadingClick"
      >
        <div class="loading-icon-wrap">
          <span class="play-icon-static">▶</span>
        </div>
        <span
          v-if="!videoLoadFailed"
          class="loading-text"
        >Video loading...</span>
        <span
          v-else
          class="loading-text"
        >Loading failed, click retry</span>
        <div
          v-if="!videoLoadFailed"
          class="loading-spinner"
        />
      </div>
		
<!--      <div
        class="player-top-bar"
        @click.stop
      >
        <div
          class="back-btn"
          @click="showToast('Return to previous page')"
        >
          ←
        </div>
        <span class="player-episode-tag">{{ currentEpisode.epLabel }}</span>
      </div> -->
      <div
        v-if="!isYouTubeVideo"
        class="player-overlay"
        @click.stop
      >
        <div
          v-show="!isPlaying && videoReady"
          class="play-center-btn"
          @click="togglePlay"
        >
          ▶
        </div>
      </div>
      <div
        v-if="!isYouTubeVideo"
        class="player-controls"
        @click.stop
      >
        <div
          ref="progressBar"
          class="progress-bar-wrap"
          @mousedown="startDrag"
          @touchstart="startDrag"
        >
          <div
            class="progress-bar-fill"
            :style="{ width: progressPercent + '%' }"
          />
        </div>
        <div class="ctrl-row">
          <div class="ctrl-left">
            <button
              class="ctrl-btn"
              @click="togglePlay"
            >
              {{ isPlaying ? '⏸' : '▶' }}
            </button>
            <span class="ctrl-time">{{ formatTime(currentTime) }} / {{ formatTime(duration) }}</span>
          </div>
          <div class="ctrl-right">
            <button
              class="speed-btn"
              @click="cycleSpeed"
            >
              {{ playbackRate }}x
            </button>
            <button
              class="ctrl-btn"
              @click="toggleFullscreen"
            >
              ⛶
            </button>
          </div>
        </div>
      </div>
    </div>
		
    <!-- 剧集信息 -->
    <div class="info-section">
      <h1 class="drama-title">
        {{ dramaTitle }}
      </h1>
      <div class="meta-info-row">
        <span class="meta-item"><span class="star-icon">★</span> {{ dramaRating }}</span>
        <span class="meta-divider" />
       
        <span class="meta-item">👁 {{ dramaViews }}</span>
      </div>
    </div>
		
    <!-- 描述 -->
    <div class="desc-section" >
      <p
        class="desc-text clamped"
        
		v-html="dramaDesc"
      >
      </p>
     
    </div>

    <!-- 所有集数 -->
    <div class="episodes-section">
      <h3 style="color: #fff;">📂 {{ $t('utils.bjsysc') }}</h3>
      <div
        ref="episodesScroll"
        class="episodes-scroll"
      >
        <div
          v-for="(ep, idx) in episodes"
          :key="ep.id"
          class="ep-card"
          :class="{ active: ep.episodes === ju }"
          @click="switchEpisode(ep.episodes)"
        >
          <div class="ep-thumb">
            <img
              :src="ep.img"
              alt=""
              loading="lazy"
            >
            <span class="ep-duration">👁 {{ ep.bofang }}</span>
          </div>
          <div class="ep-info">
            <div class="ep-num">
             <span class="star-icon">★</span> {{ ep.rating }}
            </div>
            <div class="ep-title-mini" style="font-size: 14px;font-weight: 700;line-height: 20px;">
              {{ $t('utils.ji') }} {{ ep.episodes }}
            </div>
            <div
              v-if="ep.episodes === ju"
              class="ep-playing-indicator"
            >
              ▶ {{ $t('utils.zzbf') }}
            </div>
          </div>
        </div>
      </div>
    </div>
		
    <div style="height: 80px;" />
  </div>
</template>

<script>
	import Vue from 'vue';
	import Hls from 'hls.js';
	import bsHeader from '../../components/bsHeader.vue'
	import Fetch from '../../utils/fetch'
	import * as echarts from 'echarts';
	import {
		Icon,
		Popup,
		Field,
		Cell,
		CellGroup
	} from 'vant';
	Vue.use(Icon).use(Popup).use(Field).use(Cell).use(CellGroup);
	export default {
		name: "",
		components: {
			bsHeader
		},
		data() {
			return {
				active: 0,
				empty: false,
				loading: false,
				finished: false,
				list: [],
				page: 1,
				listRows: 8,
				currentVideoSrc: '',
				dramaTitle: '',
				dramaRating: '',
				dramaViews: '',
				posters:'',
				dramaDesc: '',
				descExpanded: false,
				isPlaying: false,
				currentTime: 0,
				duration: 0,
				playbackRate: 1.0,
				speedIndex: 0,
				speedOptions: [1.0, 1.25, 1.5, 2.0],
				isDragging: false,
				videoReady: false,
				videoLoadFailed: false,
				hlsPlayer: null,
				currentEpIndex: 2,
				detail: null,
				detailLoading: false,
				detailError: false,
				episodes: [
					
				],
				toastVisible: false,
				toastMsg: '',
				ju:1,
				toastTimer: null
			};
		}, computed: {
			currentEpisode() {
				return this.episodes[this.currentEpIndex] || { epLabel: '', title: '' };
			},
			progressPercent() {
				return this.duration ? (this.currentTime / this.duration) * 100 : 0;
			},
			isYouTubeVideo() {
				return this.getYouTubeVideoId(this.currentVideoSrc) !== '';
			},
			youtubeEmbedUrl() {
				const videoId = this.getYouTubeVideoId(this.currentVideoSrc);
				return videoId ? `https://www.youtube.com/embed/${videoId}?rel=0&playsinline=1&modestbranding=1&iv_load_policy=3` : '';
			}
		},
		created() {
			if (window.plus) {
				plus.navigator.setStatusBarBackground('#FAFAFA');
				plus.navigator.setStatusBarStyle('dark');
			}
			if (this.$parent && typeof this.$parent.footer === 'function') {
				this.$parent.footer('invest', true);
			}
		},
		mounted() {
			if (this.$router && this.$router.history && this.$router.history.current && this.$router.history.current.query && this.$router.history.current.query.type) {
				this.active = parseInt(this.$router.history.current.query.type);
			}
			this.start();
			this.$nextTick(() => {
				const video = this.$refs.videoPlayer;
				if (video) {
					video.playbackRate = this.playbackRate;
				}
			});
		},
		methods: {
			start() {
				const code = this.$route.params.code;
				this.code=code;
				this.videoReady = false;
				this.videoLoadFailed = false;
				this.isPlaying = false;
				this.currentTime = 0;
				this.duration = 0;
				this.detailLoading = true;
				this.detailError = false;
				this.$nextTick(() => {
					const video = this.$refs.videoPlayer;
					if (video && !this.isYouTubeVideo) {
						video.pause();
						video.currentTime = 0;
						video.playbackRate = this.playbackRate;
					}
				});
				if (!code) {
					this.detailLoading = false;
					return;
				}
				Fetch('/index/item_ju', {
					id: code,
					ju:this.ju
				}).then(r => {
					const item = r.data.item.one;
				
					this.detail = item;
					this.dramaTitle = item.title;
					this.dramaRating = item.rating;
					this.dramaViews = item.bofang;
					this.posters = item.img;
					this.dramaDesc = item.content;
					this.currentVideoSrc = item.link;
					this.$nextTick(() => {
						this.setupVideoSource();
					});
					if (Array.isArray(r.data.item.list) && r.data.item.list) {
						this.episodes = r.data.item.list;
					}
					
					if (this.episodes.length) {
						this.currentEpIndex = 0;
					}
				}).catch(() => {
					this.detailError = true;
				}).then(() => {
					this.detailLoading = false;
				});
			},
		   showToast(msg) {
		                    if (this.toastTimer) clearTimeout(this.toastTimer);
		                    this.toastMsg = msg;
		                    this.toastVisible = true;
		                    this.toastTimer = setTimeout(() => {
		                        this.toastVisible = false;
		                    }, 1500);
		                },
                getYouTubeVideoId(url) {
                    if (typeof url !== 'string' || !url) return '';
                    const trimmedUrl = url.trim();
                    const patterns = [
                        /(?:youtube\.com\/watch\?v=|youtube\.com\/embed\/|youtu\.be\/)([A-Za-z0-9_-]{11})/i,
                        /youtube\.com\/shorts\/([A-Za-z0-9_-]{11})/i
                    ];
                    for (const pattern of patterns) {
                        const match = trimmedUrl.match(pattern);
                        if (match && match[1]) return match[1];
                    }
                    return '';
                },
                handleLoadingClick() {
                    if (this.videoLoadFailed) {
                        this.videoLoadFailed = false;
                        this.setupVideoSource();
                    }
                },
                onVideoLoaded() {
                    this.videoLoadFailed = false;
                },
                onVideoCanPlay() {
                    this.videoReady = true;
                    this.videoLoadFailed = false;
                    this.duration = this.$refs.videoPlayer.duration;
                },
                onVideoError() {
                    this.videoReady = false;
                    this.videoLoadFailed = true;
                },
                isM3U8Url(url) {
                    return typeof url === 'string' && /\.m3u8(\?.*)?$/i.test(url);
                },
                setupVideoSource() {
                    const video = this.$refs.videoPlayer;
                    if (!this.currentVideoSrc) {
                        this.videoReady = false;
                        return;
                    }
                    if (this.isYouTubeVideo) {
                        this.videoReady = true;
                        this.videoLoadFailed = false;
                        this.duration = 0;
                        this.currentTime = 0;
                        this.isPlaying = false;
                        if (this.hlsPlayer) {
                            this.hlsPlayer.destroy();
                            this.hlsPlayer = null;
                        }
                        if (video) {
                            video.pause();
                            video.removeAttribute('src');
                            video.load();
                        }
                        return;
                    }
                    if (!video) {
                        this.videoReady = false;
                        return;
                    }
                    this.videoReady = false;
                    this.videoLoadFailed = false;
                    this.duration = 0;
                    if (this.hlsPlayer) {
                        this.hlsPlayer.destroy();
                        this.hlsPlayer = null;
                    }
                    video.pause();
                    video.removeAttribute('src');
                    video.load();
                    if (this.isM3U8Url(this.currentVideoSrc) && Hls.isSupported()) {
                        const hls = new Hls({
                            maxBufferLength: 30,
                            maxBufferSize: 60 * 1000 * 1000,
                            startPosition: 0,
                            liveSyncDurationCount: 3,
                            enableWorker: true,
                            lowLatencyMode: false
                        });
                        this.hlsPlayer = hls;
                        hls.loadSource(this.currentVideoSrc);
                        hls.attachMedia(video);
                        hls.on(Hls.Events.ERROR, (event, data) => {
                            if (data.fatal) {
                                this.videoReady = false;
                                this.videoLoadFailed = true;
                            }
                        });
                    } else {
                        video.src = this.currentVideoSrc;
                        video.load();
                    }
                    this.$nextTick(() => {
                        if (video) {
                            video.playbackRate = this.playbackRate;
                        }
                    });
                },
                togglePlay() {
                    if (this.isYouTubeVideo) return;
                    if (!this.videoReady) return;
                    const video = this.$refs.videoPlayer;
                    if (!video) return;
                    if (video.paused) {
                        video.play().catch(() => {
                            this.videoLoadFailed = true;
                        });
                    } else {
                        video.pause();
                    }
                },
		                onTimeUpdate() {
		                    if (!this.isDragging) this.currentTime = this.$refs.videoPlayer.currentTime;
		                },
		                onLoadedMetadata() {
		                    this.duration = this.$refs.videoPlayer.duration;
		                },
		                onVideoEnded() {
		                    this.isPlaying = false;
		                    this.showToast('播放结束');
		                },
		                formatTime(sec) {
		                    if (isNaN(sec)) return '0:00';
		                    const m = Math.floor(sec / 60);
		                    const s = Math.floor(sec % 60);
		                    return m + ':' + (s < 10 ? '0' : '') + s;
		                },
		                cycleSpeed() {
		                    if (this.isYouTubeVideo) return;
		                    this.speedIndex = (this.speedIndex + 1) % this.speedOptions.length;
		                    this.playbackRate = this.speedOptions[this.speedIndex];
		                    this.$refs.videoPlayer.playbackRate = this.playbackRate;
		                    this.showToast('倍速 ' + this.playbackRate + 'x');
		                },
		                startDrag(e) {
		                    if (this.isYouTubeVideo) return;
		                    e.preventDefault();
		                    this.isDragging = true;
		                    const updatePos = (clientX) => {
		                        const bar = this.$refs.progressBar;
		                        if (!bar) return;
		                        const rect = bar.getBoundingClientRect();
		                        let ratio = (clientX - rect.left) / rect.width;
		                        ratio = Math.min(1, Math.max(0, ratio));
		                        const video = this.$refs.videoPlayer;
		                        if (video && this.duration) {
		                            video.currentTime = ratio * this.duration;
		                            this.currentTime = video.currentTime;
		                        }
		                    };
		                    const onMove = (e) => {
		                        const cx = e.touches ? e.touches[0].clientX : e.clientX;
		                        updatePos(cx);
		                    };
		                    const onEnd = () => {
		                        this.isDragging = false;
		                        document.removeEventListener('mousemove', onMove);
		                        document.removeEventListener('mouseup', onEnd);
		                        document.removeEventListener('touchmove', onMove);
		                        document.removeEventListener('touchend', onEnd);
		                    };
		                    document.addEventListener('mousemove', onMove);
		                    document.addEventListener('mouseup', onEnd);
		                    document.addEventListener('touchmove', onMove, { passive: false });
		                    document.addEventListener('touchend', onEnd);
		                    const clientX = e.touches ? e.touches[0].clientX : e.clientX;
		                    updatePos(clientX);
		                },
		                toggleFullscreen() {
		                    const container = document.querySelector('.player-container');
		                    if (!container) return;
		                    if (!document.fullscreenElement) {
		                        container.requestFullscreen?.() ||
		                            container.webkitRequestFullscreen?.() ||
		                            container.msRequestFullscreen?.();
		                        this.showToast('进入全屏');
		                    } else {
		                        document.exitFullscreen?.() ||
		                            document.webkitExitFullscreen?.() ||
		                            document.msExitFullscreen?.();
		                        this.showToast('退出全屏');
		                    }
		                },
		                switchEpisode(index) {
		                    this.ju=index;
							const code = this.$route.params.code;
							Fetch('/index/item_ju', {
								id: code,
								ju:this.ju
							}).then(r => {
								
								const item = r.data.item.one;
							
								this.detail = item;
								this.dramaTitle = item.title;
								this.dramaRating = item.rating;
								this.dramaViews = item.bofang;
								this.posters = item.img;
								this.dramaDesc = item.content;
								this.currentVideoSrc = item.link;
								this.$nextTick(() => {
									this.setupVideoSource();
								});
								if (Array.isArray(r.data.item.list) && r.data.item.list) {
									this.episodes = r.data.item.list;
								}
								if (this.episodes.length) {
									this.currentEpIndex = 0;
								}
							}).catch(() => {
								this.detailError = true;
							}).then(() => {
								this.detailLoading = false;
							});
		                }
			
		}
	};
</script>

<style lang="less" scoped>
	.home_wrap {
		margin-bottom: 60px;
		/* 给页面主体默认顶部内边距，避免固定头部遮挡内��*/
		padding-top: 68px;
		height: 100%;
		min-height: 100vh;
		background-color: var(--bg-primary);
		color: var(--text-primary);
	
	
	}
.player-container {
            position: relative;
            width: 100%;
            height: 440px;
            max-height: 440px;
            background: #000;
            overflow: hidden;
            touch-action: pan-y;
        }
        .video-poster {
            position: absolute;
            inset: 0;
            z-index: 1;
            background-size: cover;
            background-position: center;
            background-repeat: no-repeat;
            transition: opacity 0.4s ease;
        }
        .video-poster.hidden {
            opacity: 0;
            pointer-events: none;
        }
        .player-container video {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            object-fit: contain;
            background: #000;
            transition: opacity 0.5s ease;
            z-index: 2;
        }
        .player-container video.loading {
            opacity: 0;
        }
        .player-container video.ready {
            opacity: 1;
        }
        .youtube-player {
            position: absolute;
            inset: 0;
            width: 100%;
            height: 100%;
            z-index: 3;
            background: #000;
        }

        /* 加载占位图标 */
        .loading-placeholder {
            position: absolute;
            inset: 0;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            z-index: 5;
            pointer-events: auto;
            cursor: pointer;
            background: #000;
            transition: opacity 0.4s ease;
        }
        .loading-placeholder.hidden {
            opacity: 0;
            pointer-events: none;
        }
        .loading-icon-wrap {
            width: 80px;
            height: 80px;
            border-radius: 50%;
            background: rgba(255, 255, 255, 0.1);
            border: 2px solid rgba(255, 255, 255, 0.2);
            display: flex;
            align-items: center;
            justify-content: center;
            margin-bottom: 12px;
            animation: pulse 2s infinite;
        }
        .loading-icon-wrap .play-icon-static {
            font-size: 32px;
            color: rgba(255, 255, 255, 0.8);
            margin-left: 4px;
        }
        .loading-text {
            font-size: 13px;
            color: rgba(255, 255, 255, 0.6);
            font-weight: 500;
            letter-spacing: 0.02em;
        }
        @keyframes pulse {
            0%,
            100% {
                transform: scale(1);
                opacity: 1;
            }
            50% {
                transform: scale(1.05);
                opacity: 0.8;
            }
        }
        .loading-spinner {
            width: 24px;
            height: 24px;
            border: 3px solid rgba(255, 255, 255, 0.2);
            border-top-color: #fff;
            border-radius: 50%;
            animation: spin 0.8s linear infinite;
            margin-top: 10px;
        }
        @keyframes spin {
            to {
                transform: rotate(360deg);
            }
        }

        .player-overlay {
            position: absolute;
            inset: 0;
            display: flex;
            align-items: center;
            justify-content: center;
            z-index: 3;
            pointer-events: none;
        }
        .play-center-btn {
            width: 64px;
            height: 64px;
            border-radius: 50%;
            background: rgba(255, 255, 255, 0.9);
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 24px;
            color: #000;
            box-shadow: 0 4px 24px rgba(0, 0, 0, 0.5);
            pointer-events: auto;
            transition: 0.2s;
            cursor: pointer;
        }
        .player-top-bar {
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            padding: 12px 14px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            z-index: 4;
            background: linear-gradient(to bottom, rgba(0, 0, 0, 0.6), transparent);
        }
        .back-btn {
            width: 36px;
            height: 36px;
            border-radius: 50%;
            background: rgba(0, 0, 0, 0.5);
            backdrop-filter: blur(10px);
            border: 1px solid rgba(255, 255, 255, 0.15);
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            color: #fff;
            font-size: 16px;
        }
        .player-episode-tag {
            font-size: 12px;
            font-weight: 600;
            background: rgba(0, 0, 0, 0.5);
            backdrop-filter: blur(10px);
            padding: 6px 12px;
            border-radius: 16px;
            border: 1px solid rgba(255, 255, 255, 0.15);
        }
        .player-controls {
            position: absolute;
            bottom: 0;
            left: 0;
            right: 0;
            padding: 10px 14px 14px;
            z-index: 4;
            background: linear-gradient(to top, rgba(0, 0, 0, 0.7), transparent);
        }
        .progress-bar-wrap {
            width: 100%;
            height: 4px;
            background: rgba(255, 255, 255, 0.25);
            border-radius: 2px;
            margin-bottom: 10px;
            cursor: pointer;
        }
        .progress-bar-fill {
            height: 100%;
            background: var(--accent);
            border-radius: 2px;
            width: 0%;
            transition: width 0.1s linear;
        }
        .ctrl-row {
            display: flex;
            justify-content: space-between;
            align-items: center;
        }
        .ctrl-left {
            display: flex;
            align-items: center;
            gap: 14px;
        }
        .ctrl-btn {
            background: none;
            border: none;
            color: #fff;
            font-size: 18px;
            cursor: pointer;
            padding: 4px;
        }
        .ctrl-time {
            font-size: 11px;
            color: rgba(255, 255, 255, 0.8);
            font-variant-numeric: tabular-nums;
        }
        .ctrl-right {
            display: flex;
            align-items: center;
            gap: 12px;
        }
        .speed-btn {
            background: rgba(255, 255, 255, 0.15);
            border: none;
            color: #fff;
            font-size: 11px;
            font-weight: 600;
            padding: 4px 10px;
            border-radius: 12px;
            cursor: pointer;
        }

        /* 剧集信息 */
        .info-section {
            padding: 16px 18px 0;
        }
        .drama-title {
            font-size: 22px;
            font-weight: 800;
            margin-bottom: 8px;
        }
        .meta-info-row {
            display: flex;
            align-items: center;
            gap: 12px;
            margin-bottom: 10px;
            flex-wrap: wrap;
        }
        .meta-item {
            display: flex;
            align-items: center;
            gap: 5px;
            font-size: 13px;
            color: var(--text-secondary);
        }
        .star-icon {
            color: var(--accent-gold);
            font-size: 15px;
        }
        .meta-divider {
            width: 3px;
            height: 3px;
            background: var(--text-muted);
            border-radius: 50%;
        }
        .episode-badge {
            background: var(--bg-card);
            padding: 5px 10px;
            border-radius: 14px;
            border: 1px solid var(--border);
            font-weight: 600;
            color: #fff;
            font-size: 12px;
        }
        .action-btns {
            display: flex;
            gap: 10px;
            margin-bottom: 14px;
        }
        .action-btn {
            flex: 1;
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 6px;
            padding: 11px 0;
            border-radius: 22px;
            font-size: 12px;
            font-weight: 600;
            background: var(--bg-card);
            border: 1px solid var(--border);
            color: var(--text-secondary);
            cursor: pointer;
        }

        .desc-section {
            padding: 0 18px 10px;
            width: 100%;
            box-sizing: border-box;
            overflow: hidden;
        }
        .desc-text {
            font-size: 13px;
            color: var(--text-secondary);
            line-height: 1.65;
            width: 100%;
            max-width: 100%;
            white-space: normal;
            word-break: break-word;
            overflow-wrap: anywhere;
            overflow: hidden;
        }
        .desc-text.clamped {
            
        }
        .desc-toggle {
            font-size: 12px;
            color: var(--accent-blue);
            font-weight: 600;
            cursor: pointer;
        }

        .episodes-section {
            padding: 0 0 0 18px;
            margin-bottom: 10px;
        }
        .episodes-section h3 {
            font-size: 16px;
            font-weight: 700;
            margin-bottom: 10px;
        }
        .episodes-scroll {
            display: flex;
            gap: 10px;
            overflow-x: auto;
            scroll-behavior: smooth;
            -webkit-overflow-scrolling: touch;
            touch-action: pan-x;
            padding-right: 18px;
        }
        .ep-card {
            flex-shrink: 0;
            width: 130px;
            background: var(--bg-card);
            border-radius: var(--radius-md);
            overflow: hidden;
            cursor: pointer;
            border: 2px solid transparent;
            transition: 0.2s;
        }
        .ep-card.active {
            border-color: var(--accent);
            box-shadow: 0 0 16px rgba(229, 9, 20, 0.3);
        }
        .ep-thumb {
            width: 100%;
            aspect-ratio: 16/9;
            position: relative;
            overflow: hidden;
        }
        .ep-thumb img {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            object-fit: cover;
        }
        .ep-duration {
            position: absolute;
            bottom: 6px;
            right: 6px;
            background: rgba(0, 0, 0, 0.7);
            color: #fff;
            font-size: 9px;
            font-weight: 600;
            padding: 2px 6px;
            border-radius: 8px;
        }
        .ep-info {
            padding: 8px 10px 10px;
        }
        .ep-num {
            font-size: 11px;
            font-weight: 700;
            color: #fff;
            margin-bottom: 2px;
        }
        .ep-title-mini {
            font-size: 10px;
            color: var(--text-muted);
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }
        .ep-playing-indicator {
            font-size: 9px;
            color: var(--accent);
            font-weight: 700;
            margin-top: 3px;
        }

        .bottom-nav {
            position: fixed;
            bottom: 0;
            left: 50%;
            transform: translateX(-50%);
            width: 100%;
            max-width: 430px;
            background: rgba(8, 8, 12, 0.96);
            backdrop-filter: blur(28px);
            -webkit-backdrop-filter: blur(28px);
            border-top: 1px solid var(--border);
            display: flex;
            justify-content: space-around;
            padding: 10px 0 calc(10px + var(--safe-bottom));
            z-index: 200;
        }
        .nav-tab {
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: 5px;
            color: var(--text-muted);
            font-size: 10px;
            font-weight: 500;
            cursor: pointer;
        }
        .nav-tab .tab-icon {
            font-size: 22px;
        }

        .toast {
            position: fixed;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%) scale(0.85);
            background: rgba(28, 28, 38, 0.96);
            color: #fff;
            padding: 14px 28px;
            border-radius: 28px;
            font-size: 14px;
            font-weight: 600;
            z-index: 999;
            pointer-events: none;
            opacity: 0;
            transition: all 0.35s;
        }
        .toast.show {
            opacity: 1;
            transform: translate(-50%, -50%) scale(1);
        }
		.episodes-scroll::-webkit-scrollbar {
		    display: none;
		}
</style>
